"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _clean = _interopRequireDefault(require("./clean"));

var Shortcode = /*#__PURE__*/function () {
  function Shortcode(start, end, text) {
    (0, _classCallCheck2["default"])(this, Shortcode);
    this.text = text.trim();
    this.start = start;
    this.end = end;
    this.type = 'shortcode';
    this.identifier = this.setIdentifier();
    this.attributes = this.setAttributes();
  }

  (0, _createClass2["default"])(Shortcode, [{
    key: "setIdentifier",
    value: function setIdentifier() {
      var _this$text$split = this.text.split(' '),
          _this$text$split2 = (0, _slicedToArray2["default"])(_this$text$split, 1),
          identifier = _this$text$split2[0];

      return identifier;
    }
  }, {
    key: "setAttributes",
    value: function setAttributes() {
      var attributes = {};
      var attrs = this.text.trim().match(/(?:[\w-]*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^}\s]+))/g);

      if (attrs) {
        for (var i = 0; i < attrs.length; i += 1) {
          var _attrs$i$split = attrs[i].split('='),
              _attrs$i$split2 = (0, _slicedToArray2["default"])(_attrs$i$split, 2),
              key = _attrs$i$split2[0],
              value = _attrs$i$split2[1];

          attributes[(0, _clean["default"])(key)] = (0, _clean["default"])(value);
        }
      }

      return attributes;
    }
  }]);
  return Shortcode;
}();

var _default = Shortcode;
exports["default"] = _default;